import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { login } from '../lib/api'
import { Input } from '../components/ui/Input'
import { Button } from '../components/ui/Button'

const schema = z.object({
  email: z.string().email('Enter a valid email'),
  password: z.string().min(1, 'Password is required'),
})

export default function Login() {
  const navigate = useNavigate()
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: zodResolver(schema) })

  const mutation = useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      localStorage.setItem('token', data.token)
      localStorage.setItem('user', JSON.stringify(data.user))
      navigate('/')
    },
    onError: (err) => toast.error(err.message),
  })

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-900 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex w-14 h-14 bg-indigo-500 rounded-2xl items-center justify-center shadow-lg mb-4">
            <i className="ti ti-map-pin text-white text-2xl" />
          </div>
          <h1 className="text-2xl font-bold text-white">AfghanSpot</h1>
          <p className="text-slate-400 text-sm mt-1">Sign in to Admin Panel</p>
        </div>

        {/* Form */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <form onSubmit={handleSubmit(d => mutation.mutate(d))} className="space-y-5">
            <Input
              label="E-posta"
              type="email"
              placeholder="admin@afghnaspot.com"
              error={errors.email?.message}
              {...register('email')}
            />
            <Input
              label="Password"
              type="password"
              placeholder="••••••••"
              error={errors.password?.message}
              {...register('password')}
            />
            <Button
              type="submit"
              className="w-full"
              size="lg"
              loading={mutation.isPending}
              disabled={mutation.isPending}
            >
              {!mutation.isPending && <i className="ti ti-login" />}
              Sign In
            </Button>
          </form>
        </div>

        <p className="text-center text-slate-500 text-xs mt-6">
          AfghanSpot © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  )
}
